import { render, staticRenderFns } from "./user-static-choice-message.vue?vue&type=template&id=8daa1e76&scoped=true&"
import script from "./user-static-choice-message.vue?vue&type=script&lang=js&"
export * from "./user-static-choice-message.vue?vue&type=script&lang=js&"
import style0 from "./user-static-choice-message.vue?vue&type=style&index=0&id=8daa1e76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daa1e76",
  null
  
)

export default component.exports